import axios from "./request"

// 获取登录页面
export function applyfortoken (data) {
    return axios.get(`/oauth/applyfortoken?redirectUrl=${data}`)
}

// 获取token
export function getTokenApi (data) {
    return axios.get(`/oauth/auth/authorization_code_callback`, {params:data})
}

// 获取弹幕数据
export function getWishList (data) {
    return axios.post(`/wish/list`, data)
}

// 获取太阳码
export function getQrImg (data) {
    return axios.post(`/wish/code/sun/generate/common`, data)
}

// 获取本人心愿详情
export function wishDetail (data) {
    return axios.post(`/wish/myWishList`,data)
}

// 获取 URL Scheme 跳转到小程序
export function getScheme (data) {
    return axios.post(`/genSchemeUrlOnly`, data)
}

// 获取 首页视频的链接
export function qryMVUrl (data) {
    return axios.post(`/wish/qryMVUrl`, data)
}

// 获取 活动结束时间
export function qryWishTime (data) {
    return axios.post(`/wish/qryWishTime`, data)
}

// h5二维码获取登录页面
export function applyfortokenQywx (data) {
    return axios.get(`/oauth/applyfortoken?qywxUrl=${data}`, data)
}
// 抽奖查询活动详情
export function queryActivityDetail(data) { 
    return axios.post('/roll-lottery/qryActivityDetail',data)
}
// 上传中奖人数
export function qryRewardPerson(data) { 
    return axios.post('/roll-lottery/winnersRecord',data)
}

// 获取心愿抽奖结果
export function qryWishDraw(data) { 
    return axios.post('/wish/qryWishDraw',data)
}

// 获取心愿抽奖结果加抽奖
export function doWishDraw(data) { 
    return axios.post('/wish/wishDraw',data)
}

// 点赞
export function wishLike(data) { 
    return axios.post('/wish/like',data)
}
